<template>
  <div>
    <p v-if="labelPosition === 'top'" :class="paymentsTitleClassList">Payments</p>
    <div v-if="isActive" class="row q-col-gutter-sm" :class="{ 'repayment-options__row--stretch': fullWidthButtons }">
      <span
        v-if="labelPosition === 'left'"
        :class="['text-primary', ...[].concat(labelStyles)]"
        style="font-size: 16px; margin: 8px 12px 0px"
      >
        Payments
      </span>
      <CheckboxButton
        label="Weekly"
        :value="isWeekly"
        outlined
        :rounded="fullWidthButtons"
        :full-width="fullWidthButtons"
        @input="$emit('input', 'weekly')"
        :disabled="isWeekly"
        removeOpacity
      />
      <CheckboxButton
        label="Monthly"
        :value="isMonthly"
        outlined
        :rounded="fullWidthButtons"
        :full-width="fullWidthButtons"
        @input="$emit('input', 'monthly')"
        :disabled="isMonthly"
        removeOpacity
      />
    </div>
    <div v-else class="row q-col-gutter-sm" :class="{ 'repayment-options__row--stretch': fullWidthButtons }">
      <CheckboxButton
        label="Weekly"
        outlined
        :rounded="fullWidthButtons"
        :full-width="fullWidthButtons"
        @input="updateRepaymentOption('weekly')"
        :disabled="true"
        removeOpacity
      />
      <CheckboxButton
        label="Monthly"
        outlined
        :rounded="fullWidthButtons"
        :full-width="fullWidthButtons"
        @input="updateRepaymentOption('monthly')"
        :disabled="true"
        removeOpacity
      />
    </div>
  </div>
</template>
<script>
import { REPAYMENT_MONTHLY, REPAYMENT_WEEKLY } from '../../utils/constants';
import CheckboxButton from './CheckboxButton';
export default {
  props: {
    value: {
      type: String,
      default: REPAYMENT_WEEKLY
    },
    labelPosition: {
      type: String,
      default: 'top'
    },
    labelStyles: {
      type: [String, Array],
      default: () => ['text-weight-bolder']
    },
    isActive: {
      type: Boolean,
      default: true
    },
    /** Equal-width toggles (e.g. mobile filter drawer). */
    fullWidthButtons: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isWeekly() {
      return this.value === REPAYMENT_WEEKLY;
    },
    isMonthly() {
      return this.value === REPAYMENT_MONTHLY;
    },
    /** Matches VehicleResultFilterDrawer section label when used in mobile drawer (`fullWidthButtons`). */
    paymentsTitleClassList() {
      const styles = [].concat(this.labelStyles);
      return [
        'col-12',
        'text-primary',
        'repayment-options__title',
        ...styles,
        this.fullWidthButtons && 'repayment-options__title--mobile-drawer'
      ].filter(Boolean);
    }
  },
  methods: {
    updateRepaymentOption(option) {
      this.$emit('input', option);
    }
  },
  components: {
    CheckboxButton
  }
};
</script>

<style lang="sass" scoped>
@import '../../styles/calculator/variables'
@import '../../styles/calculator/vehicle-result-page-breakpoints'

.repayment-options__title
  font-size: 16px
  margin: 0 0 5px
  @media (max-width: $vr-layout-compact-max)
    margin: 0 0 8px

.repayment-options__title--mobile-drawer
  font-size: 18px
  line-height: 150%
  font-family: #{'var(--calculator-font-family, ' + $font-baloo + ')'};

.repayment-options__row--stretch
  flex-wrap: nowrap
  .checkbox-button
    flex: 1
    min-width: 0
</style>
